export default function otpDirektController() {
	var $ctrl = this;

	// todo a nyilatkozat letöltés functiont megírni itt
	$ctrl.downloadStatement = function () {
		window.location.href = '/welcome/downloadStatement';
	};

	$ctrl.goToWelcomePage = function () {
		if (angular.isDefined($ctrl.goToWelcomePageFunction)) {
			$ctrl.goToWelcomePageFunction();
		}
	};
}
